import { render, staticRenderFns } from "./columnsGray.vue?vue&type=template&id=b897a622&scoped=true&"
import script from "./columnsGray.vue?vue&type=script&lang=js&"
export * from "./columnsGray.vue?vue&type=script&lang=js&"
import style0 from "./columnsGray.vue?vue&type=style&index=0&id=b897a622&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897a622",
  null
  
)

export default component.exports